import Countdown from "@/components/Countdown";
import ContractAddress, { PUMP_FUN_URL } from "@/components/ContractAddress";
import { ArrowRight, Zap } from "lucide-react";

const HERO_BG =
  "https://images.unsplash.com/photo-1579156618441-0f9f420e2a25?fm=jpg&q=80&w=2400&auto=format&fit=crop";

export default function Hero() {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen w-full overflow-hidden flex items-center justify-center"
    >
      {/* Background */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${HERO_BG})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#05050A]/55 via-[#05050A]/45 to-[#05050A]" />
      <div className="absolute inset-0 bg-cyber-grid opacity-35" />
      <div className="absolute inset-0 bg-noise mix-blend-overlay pointer-events-none" />

      {/* Scanline */}
      <div className="absolute inset-x-0 top-0 h-screen overflow-hidden pointer-events-none">
        <div className="absolute inset-x-0 h-px bg-[#00F0FF]/40 blur-sm animate-scanline" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 py-32 text-center">
        {/* Ticker chip */}
        <div className="inline-flex items-center gap-2 px-4 py-1.5 border border-[#00F0FF]/40 bg-[#00F0FF]/5 text-[#00F0FF] font-mono text-[10px] tracking-[0.32em] mb-8 animate-pulse-glow">
          <Zap className="w-3 h-3" />
          <span data-testid="hero-ticker">SOLANA · PUMP.FUN · FAIR LAUNCH</span>
        </div>

        {/* Headline */}
        <h1
          data-testid="hero-headline"
          aria-label="Join the LA28 Army"
          className="font-heading text-5xl sm:text-7xl lg:text-8xl font-black tracking-tighter text-white leading-[0.95]"
        >
          JOIN THE{" "}
          <br />
          <span className="text-[#00F0FF] glow-text">LA28 ARMY</span>
        </h1>

        <p
          data-testid="hero-subheadline"
          className="mt-8 text-base sm:text-lg text-white/75 max-w-2xl mx-auto leading-relaxed"
        >
          LA28 Army is a community-led meme movement tracking the road to the
          most watched sporting events of{" "}
          <span className="text-[#FFD700] font-semibold">2028</span>. No
          promises, no fluff—just momentum, memes, and belief that the next
          cycle starts early.{" "}
          <span className="text-white font-semibold">
            Join the army or watch from the sidelines.
          </span>
        </p>

        {/* Countdown */}
        <div className="mt-14">
          <div className="text-[10px] font-mono tracking-[0.4em] text-white/50 mb-5">
            // T-MINUS UNTIL JULY 14, 2028
          </div>
          <Countdown />
        </div>

        {/* CTAs */}
        <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            data-testid="hero-cta-join"
            href="#community"
            className="btn-neon"
          >
            JOIN THE ARMY <ArrowRight className="w-4 h-4" />
          </a>
          <a
            data-testid="hero-cta-buy"
            href={PUMP_FUN_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-neon btn-gold"
          >
            BUY ON PUMP.FUN
          </a>
        </div>

        {/* Contract Address */}
        <div className="mt-10 flex justify-center">
          <ContractAddress />
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 inset-x-0 flex justify-center">
        <div
          data-testid="hero-scroll-indicator"
          className="font-mono text-[10px] tracking-[0.4em] text-white/40"
        >
          SCROLL ↓
        </div>
      </div>
    </section>
  );
}
